export const getTitleColor = (completed: boolean, isOverdue: boolean, isToday: boolean): string => {
  if (completed) {
    return 'text-gray-500 dark:text-gray-500 line-through';
  }
  if (isOverdue) {
    return 'text-red-500';
  }
  if (isToday && !completed) {
    return 'text-green-600 dark:text-green-500';
  }
  return 'text-gray-900 dark:text-white';
};

export const getDateColor = (completed: boolean, isOverdue: boolean, isToday: boolean): string => {
  if (completed) {
    return 'text-gray-500 dark:text-gray-600 line-through';
  }
  if (isOverdue) {
    return 'text-red-500';
  }
  if (isToday && !completed) {
    return 'text-green-600 dark:text-green-500';
  }
  return 'text-gray-700 dark:text-gray-400';
};

export const getIconColor = (completed: boolean, isOverdue: boolean, isToday: boolean): string => {
  if (completed) {
    return 'text-gray-400 dark:text-gray-500';
  }
  if (isOverdue && !completed) {
    return 'text-red-500';
  }
  if (isToday && !completed) {
    return 'text-green-600 dark:text-green-500';
  }
  return 'text-gray-700 dark:text-gray-400';
};

export const getNameColor = (completed: boolean, isOverdue: boolean, isToday: boolean): string => {
  if (completed) {
    return 'text-gray-500 dark:text-gray-600';
  }
  if (isOverdue && !completed) {
    return 'text-red-500';
  }
  if (isToday && !completed) {
    return 'text-green-600 dark:text-green-500';
  }
  return 'text-gray-700 dark:text-gray-400';
};
